export default __webpack_public_path__ + "static/media/Ies_Ledvance.7419e609.png";